import accountsActionCreators, { actionTypes } from './accountsActions';

export default accountsActionCreators;
export { actionTypes };
